import axios from 'axios';
import config from '../config';


const apiRootURI = config.readapi || "http://api.localhost";
const apiBaseUrl = () => {
  return apiRootURI;
};

function getQueryString(params) {
  if (!params) {
    return '';
  }
  let esc = encodeURIComponent;
  return Object.keys(params)
    .map(k => {
      let param = esc(params[k]);
      if (params[k].constructor === Array) {
        let myParams = params[k].map(p => esc(p));
        if (k === 'filter[tags]') {
          param = myParams.join(',,');
        } else {
          param = myParams.join(',');
        }
      }
      return k + '=' + param;
    })
    .join('&');
}


function post(url, data, responseHandler, errorHandler) {
  console.log("POST url: " + url);
  return axios.post(url, data).then(({data}) => {
    responseHandler(data);
  }, (error) => {
    if (errorHandler) {
      errorHandler(error);
    }
    else {
      console.error(error);
    }
  });
}

// TODO Error Handler

function get(url, responseHandler, errorHandler, data) {
  data = data ? {params: data} : {};
  return axios.get(url, data).then(({data}) => {
    responseHandler(data);
  }, (error) => {
    if (errorHandler) {
      errorHandler(error);
    }
    else {
      console.error(error);
    }
  });
}

const apiRoutes = {
  autocomplete: {
    get: () => `${apiBaseUrl()}/_autocomplete`,
    tags: () => `${apiBaseUrl()}/_tags`
  },
  tags: {
    getAll: (language) => `${apiBaseUrl()}/tags?sort=pref_${language}&page[limit]=-1`
  },
  query: {
    post: () => `${apiBaseUrl()}/_query`
  },
  annotatedTexts: {
    get: (language) => `${apiBaseUrl()}/_annotatedTexts?language=${language}`
  },
  lastadjustments: {
    get: () => `${apiBaseUrl()}/_latest`
  },
  structures: {
    getAll: () => `${apiBaseUrl()}/structures`,
    get: (id) => `${apiBaseUrl()}/structures/${id}`,
    getPublication: (id, language) => `${apiBaseUrl()}/structures?publication=${id}&language=${language}`,
    getVersions: (id, type) => `${apiBaseUrl()}/structures/${id}/versions?type=${type}`
  },
  articles: {
    get: (id) => `${apiBaseUrl()}/articles/${id}`,
    getVersions: (id, type) => `${apiBaseUrl()}/articles/${id}/versions?type=${type}`,
    getFromConcept: (conceptId, language = null) => {
      let url = `${apiBaseUrl()}/articles?concept=${conceptId}`;
      if (language) {
        url += '&language=' + language;
      }
      return url;
    }
  },
  elements: {
    get: (id) => `${apiBaseUrl()}/elements/${id}`,
    getAnnotations: (id) => `${apiBaseUrl()}/elements/${id}/annotations`,
    getConcept: (id) => `${apiBaseUrl()}/elements?filter[canonical]=${id}`,
    getVersions: (id, type) => `${apiBaseUrl()}/elements/${id}/versions?type=${type}`
  },
  annotations: {
    get: (id) => `${apiBaseUrl()}/annotations/${id}`
  },
  batch: {
    getEmpty: (selection) => `${apiBaseUrl()}/batch`,
    get: (selection) => `${apiBaseUrl()}/batch${selection}`
  },
  feeds: {
    latest: () => `${apiBaseUrl()}/feeds/latest`,
    query: (query) => `${apiBaseUrl()}/feeds/query?` + getQueryString(query),
  },
  sendcontactmail: {
    post: () => `${apiBaseUrl()}/sendcontactmail`
  }
};

export {apiRoutes, post, get};



/** WEBPACK FOOTER **
 ** ./src/api/api.js
 **/